import React from "react";
import { Box, Typography } from "@mui/material";

const PolygonBoxBottom = ({ number = 22, color = "red", width = 30, height = 30 }) => {
  return (
    <Box
      sx={{
        width: `${width}px`,
        height: `${height}px`,
        backgroundColor: color,
        clipPath: "polygon(70.71% 100%, 100% 70.71%, 100% 29.29%, 100% 0%, 0% 0%, 0% 29.29%, 0% 70.71%, 29.29% 100%)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        fontWeight: "bold",
        // fontSize: "1rem",
        boxShadow: "2px 2px 6px rgba(0,0,0,0.3)", // optional shadow
      }}
    >
      <Typography
        sx={{
        //   position: "absolute",
        //   top: "50%",
        //   left: "50%",
        //   transform: "translate(-50%, -50%)",
        }}
      >
        {number}
      </Typography>
    </Box>
  );
};

export default PolygonBoxBottom;
